// extracted by mini-css-extract-plugin
export var labelWrapper = "_gs-0";